module.exports = __webpack_public_path__ + "static/handbookIntro@2-0f54e41f4c41de0856bc63278d2361dc.png";